import { useEffect, useState, useRef } from "react";
import { api } from "../lib/api";
import DialogMetricasSistema from "./DialogMetricasSistema";

// RodapeMetricas: fixo no rodapé, mostra % CPU e % RAM do servidor.
// Poll a cada 4s. Silencioso em caso de erro (não polui a UI).
// Os medidores são clicáveis e abrem um popup com gráficos em tempo real.
export default function RodapeMetricas() {
    const [m, setM] = useState({ cpu_pct: null, ram_pct: null, online: true });
    const [dialogAberto, setDialogAberto] = useState(false);
    const ativo = useRef(true);

    useEffect(() => {
        ativo.current = true;
        const tick = async () => {
            try {
                const r = await api.get("/sistema/metricas");
                if (!ativo.current) return;
                setM({ cpu_pct: r.data.cpu_pct, ram_pct: r.data.ram_pct, online: true });
            } catch {
                if (ativo.current) setM((p) => ({ ...p, online: false }));
            }
        };
        tick();
        const id = setInterval(tick, 4000);
        return () => { ativo.current = false; clearInterval(id); };
    }, []);

    const corCPU = corPorPct(m.cpu_pct);
    const corRAM = corPorPct(m.ram_pct);

    const abrirDialog = () => setDialogAberto(true);

    return (
        <>
            <footer
                data-testid="rodape-metricas"
                className="fixed bottom-0 left-0 right-0 z-40 border-t border-zinc-800/80 bg-zinc-950/85 backdrop-blur-md"
            >
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-7 flex items-center justify-end gap-4 text-[10px] font-mono uppercase tracking-wider text-zinc-500">
                    <div className="flex items-center gap-4">
                        <Medidor rotulo="CPU" pct={m.cpu_pct} cor={corCPU} onClick={abrirDialog} />
                        <Medidor rotulo="RAM" pct={m.ram_pct} cor={corRAM} onClick={abrirDialog} />
                    </div>
                </div>
            </footer>
            <DialogMetricasSistema aberto={dialogAberto} setAberto={setDialogAberto} />
        </>
    );
}

function Medidor({ rotulo, pct, cor, onClick }) {
    const valor = pct == null ? "--" : `${pct.toFixed(0)}%`;
    return (
        <button
            type="button"
            onClick={onClick}
            title="Clique para ver detalhes em tempo real"
            className="flex items-center gap-2 cursor-pointer hover:bg-zinc-800/40 px-1.5 py-0.5 rounded transition-colors focus:outline-none focus:ring-1 focus:ring-zinc-600"
            data-testid={`medidor-${rotulo.toLowerCase()}`}
        >
            <span className="text-zinc-600">{rotulo}</span>
            <div className="w-16 h-1.5 bg-zinc-800 rounded-full overflow-hidden">
                <div
                    className={`h-full rounded-full transition-all duration-700 ${cor.barra}`}
                    style={{ width: pct == null ? "0%" : `${Math.min(100, Math.max(0, pct))}%` }}
                />
            </div>
            <span className={`font-medium tabular-nums w-9 text-right ${cor.texto}`}>{valor}</span>
        </button>
    );
}

function corPorPct(pct) {
    if (pct == null) return { barra: "bg-zinc-700", texto: "text-zinc-500" };
    if (pct < 60) return { barra: "bg-emerald-500", texto: "text-emerald-400" };
    if (pct < 85) return { barra: "bg-yellow-500", texto: "text-yellow-400" };
    return { barra: "bg-red-500", texto: "text-red-400" };
}
